const driverShiftsTemplates = {
  table: {
    headers: {
      name: 'Name',
      shiftStart: 'Schichtbeginn',
      shiftEnd: 'Schichtende',
      breakStart: 'Pausenbeginn',
      breakEnd: 'Pausenende',
      breakNumberStart: 'Pause {{num}} Beginn',
      breakNumberEnd: 'Pause {{num}} Ende',
    },
    actions: {
      delete: 'Löschen',
    },
    toolTip: {
      noPermission: 'Sie haben keine Berechtigung, diese Aktion auszuführen',
    },
  },
  deleteModal: {
    header: 'Löschen',
    body: 'Möchten Sie die Schichtvorlage(n) wirklich löschen?',
  },
  deleteToast: {
    body: 'Schichtvorlage erfolgreich gelöscht',
  },
  form: {
    title: 'Schichtvorlage',
    templateNameHeader: 'Vorlagenname',
    displayName: 'Anzeigename',
    templateInfoHeader: 'Vorlageninfo',
    shiftStart: 'Schichtbeginn',
    shiftEnd: 'Schichtende',
    breakStart: 'Pausenbeginn',
    breakEnd: 'Pausenende',
    addBreak: 'Pause hinzufügen',
    overnightNote: 'Dies ist eine Nachtschicht',
    durationError: 'Die Schichtdauer darf 23:59 nicht überschreiten',
    breakOutsideShiftError: 'Pausen müssen innerhalb der Schichtzeiten liegen',
    footer: {
      create: 'Absenden',
      update: 'Speichern',
    },
  },
  create: {
    success: 'Schichtvorlage erfolgreich erstellt',
    error: 'Schichtvorlage konnte nicht erstellt werden',
  },
  update: {
    success: 'Schichtvorlage erfolgreich aktualisiert',
    error: 'Schichtvorlage konnte nicht aktualisiert werden',
  },
};

export default driverShiftsTemplates;
